
export const loginUser = (email, password) => {
  const VALID_EMAIL = "agridinnov@gmail.com";
  const VALID_PASSWORD = "agrid123";

  if (email === VALID_EMAIL && password === VALID_PASSWORD) {
    localStorage.setItem('isLoggedIn', 'true');
    return { success: true };
  }
  return { success: false, message: "Email atau Password salah!" };
};

export const logoutUser = () => {
  localStorage.removeItem('isLoggedIn');
  window.location.href = "/";
};